import { useCallback, type MouseEvent } from 'react';
import { useSession } from './session';

/**
 * Klikken op links in een bericht melden (FBK-11).
 *
 * De link opent zoals altijd; de melding gaat er los naast, met het token van de lezer. Mislukt ze
 * (offline, geen recht), dan merkt de lezer daar niets van: een gemiste klik in een rapport is
 * erger dan niets, maar minder erg dan een link die niet opent.
 */
export function useLinkClickTracker(postId: string | undefined) {
  const { api } = useSession();
  return useCallback(
    (event: MouseEvent<HTMLElement>) => {
      if (!postId) return;
      const anchor = (event.target as HTMLElement).closest('a[href]');
      const url = anchor?.getAttribute('href') ?? '';
      if (!/^https?:\/\//i.test(url)) return;
      void api
        .POST('/api/v1/feed/{postId}/link-clicks', {
          params: { path: { postId } },
          body: { url } as never,
        })
        .catch(() => undefined);
    },
    [api, postId],
  );
}
